import { render, staticRenderFns } from "./EmailApp.vue?vue&type=template&id=40224636&scoped=true"
import script from "./EmailApp.vue?vue&type=script&lang=js"
export * from "./EmailApp.vue?vue&type=script&lang=js"
import style0 from "./EmailApp.vue?vue&type=style&index=0&id=40224636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40224636",
  null
  
)

export default component.exports